export const GET_GIFS = 'GET_GIFS'
export const ADD_GIFS = 'ADD_GIFS'

export const SET_OFFSET = 'SET_OFFSET'
export const RESET_OFFSET = 'RESET_OFFSET'

export const RESET = 'RESET'
export const RESET_ERROR = 'RESET_ERROR'
export const RESET_SEARCH_STATE = 'RESET_SEARCH_STATE'
export const RESET_SEARCH_RETURN_TO_NULL = 'RESET_SEARCH_RETURN_TO_NULL'

export const LOADING = 'LOADING'
export const LOADED = 'LOADED'
export const LOADING_MORE = 'LOADING_MORE'
export const ERROR = 'ERROR'

export const TOGGLE_SEARCH_STATE = 'TOGGLE_SEARCH_STATE'
export const SEARCH_RETURN_NULL = 'SEARCH_RETURN_NULL'



// WEBPACK FOOTER //
// ./src/store/Types.js